import React, { useState, useMemo, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export function QueryForm(
  props: Readonly<{
    onClose: () => void;
    onProceed: (queryParams: Record<string, string>) => void;
    queryParams?: Record<string, string>;
  }>
) {
  const [params, setParams] = useState(props.queryParams ?? {});
  const isValid = useMemo(() => Object.values(params).every(Boolean), [params]);

  useEffect(() => {
    if (!props.queryParams) {
      props.onClose();
      props.onProceed(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!props.queryParams) {
    return null;
  }

  function handleProceed() {
    props.onClose();
    props.onProceed(params);
  }

  return (
    <Dialog fullWidth={true} onClose={props.onClose} open={true}>
      <DialogTitle>
        {'Enter Required Details'}
        <IconButton onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {Object.keys(params).map((key) => (
          <TextField
            fullWidth
            key={key}
            label={key}
            margin="normal"
            onChange={(e) =>
              setParams((s) => ({ ...s, [key]: e.target.value }))
            }
            value={params[key]}
          />
        ))}
      </DialogContent>
      <DialogActions sx={{ px: 3 }}>
        <Button
          disabled={!isValid}
          onClick={handleProceed}
          variant="newContained"
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
